/* eslint-disable max-len */
export function HourglassIcon(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 9.16667C10.9167 9.16667 11.7014 8.84028 12.3542 8.1875C13.0069 7.53472 13.3333 6.75 13.3333 5.83333V3.33333H6.66667V5.83333C6.66667 6.75 6.99306 7.53472 7.64583 8.1875C8.29861 8.84028 9.08333 9.16667 10 9.16667ZM3.33333 18.3333V16.6667H5V14.1667C5 13.3194 5.19792 12.5243 5.59375 11.7812C5.98958 11.0382 6.54167 10.4444 7.25 10C6.54167 9.55556 5.98958 8.96181 5.59375 8.21875C5.19792 7.47569 5 6.68056 5 5.83333V3.33333H3.33333V1.66667H16.6667V3.33333H15V5.83333C15 6.68056 14.8021 7.47569 14.4062 8.21875C14.0104 8.96181 13.4583 9.55556 12.75 10C13.4583 10.4444 14.0104 11.0382 14.4062 11.7812C14.8021 12.5243 15 13.3194 15 14.1667V16.6667H16.6667V18.3333H3.33333Z"
        fill="#F6BC2F"
      />
    </svg>
  );
}
